import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import { Box } from "@mui/material";
import api from "app/api";
import {
  AvatarFile,
  Button,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  Spacer,
  TextField,
  Toolbar,
  useDownloadUrl,
} from "common";
import ChangeEmailDialog from "features/auth/ChangeEmailDialog";
import ChangePasswordDialog from "features/auth/ChangePasswordDialog";
import I18n from "i18n";
import { useState } from "react";
import useProfileFrom from "./useProfileFrom";

export default function ProfileForm() {
  const { item, errors, loading, onChange, updateProfile, getIsDirty } =
    useProfileFrom();
  const { uploadFile } = api.getService("files");
  const { downloadUrl } = useDownloadUrl();
  const avatarUri = downloadUrl(item.file_id);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [changeEmailOpen, setChangeEmailOpen] = useState(false);

  return (
    <Box maxWidth="sm">
      <PageHeader
        avatar={<PersonIcon />}
        title={I18n.t("Profile.title")}
        backUrl=".."
      />
      <Spacer h={2} />
      <Form
        loading={loading}
        item={item}
        errors={errors}
        onChange={onChange}
        translationCategory="Profile.attributes"
        isDirty={getIsDirty}
      >
        <FieldsContainer>
          <Field fullWidth sx={{ justifyContent: "center", display: "flex" }}>
            <AvatarFile
              value={item.file_id}
              id="file_id"
              upload={uploadFile}
              uri={avatarUri}
              buttonSize="medium"
              size={80}
              buttonsPlacement="bottom"
              sx={{
                border: theme => `solid 3px ${theme.palette.action.active}`,
              }}
            />
          </Field>
          <Field xs={12} md={6}>
            <TextField id="last_name" />
          </Field>
          <Field xs={12} md={6}>
            <TextField id="first_name" />
          </Field>
          <Field fullWidth>
            <TextField id="phone" />
          </Field>
        </FieldsContainer>
      </Form>
      <Spacer h={2} />
      <Toolbar>
        <Button
          variant="outlined"
          startIcon={<LockIcon />}
          onClick={() => setChangePasswordOpen(true)}
          disabled={loading}
        >
          {I18n.t("Profile.changePassword")}
        </Button>
        <Button
          variant="outlined"
          startIcon={<EmailIcon />}
          onClick={() => setChangeEmailOpen(true)}
          disabled={loading}
          sx={{ ml: 1 }}
        >
          {I18n.t("Profile.changeEmail")}
        </Button>
        <Spacer right />
        <Button
          loading={loading}
          onClick={() => updateProfile()}
          disabled={!getIsDirty()}
        >
          {I18n.t("App.save")}
        </Button>
      </Toolbar>

      <ChangePasswordDialog
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
      />

      <ChangeEmailDialog
        open={changeEmailOpen}
        onClose={() => setChangeEmailOpen(false)}
        currentEmail={item.email || ""}
      />
    </Box>
  );
}
